import axios from 'axios';

import {
  openErrorPopup,
  openPopup,
  closePopup,
} from 'containers/App/actions';

import {
  FETCH_ACTIONS,
  FETCH_ACTIONS_SUCCESS,
  FETCH_ACTIONS_ERROR,
  FETCH_TV_CONSOLES,
  FETCH_TV_CONSOLES_SUCCESS,
  FETCH_TV_CONSOLES_ERROR,
  FETCH_POINTS,
  FETCH_POINTS_SUCCESS,
  FETCH_POINTS_ERROR,
  SAVE_ACTIONS,
  SAVE_ACTIONS_SUCCESS,
  SAVE_ACTIONS_ERROR,
  SAVE_TV_ACTIONS,
  SAVE_TV_ACTIONS_SUCCESS,
  SAVE_TV_ACTIONS_ERROR,
  TOGGLE_NOTIFICATION_POINT,
  TOGGLE_NOTIFICATION_POINT_SUCCESS,
  TOGGLE_NOTIFICATION_POINT_ERROR,
  TOGGLE_POINT_EDITING_STATE,
  SAVE_NOTIFICATION_POINT,
  SAVE_NOTIFICATION_POINT_SUCCESS,
  SAVE_NOTIFICATION_POINT_ERROR,
  CONFIRM_NOTIFICATION_POINT_CODE,
  CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  SEND_NOTIFICATION_POINT_CODE,
  SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  SEND_NOTIFICATION_POINT_CODE_ERROR,
  TOGGLE_CONFIRMATION_CODE_POPUP,
  RESET_ERROR,
  CONFIRMATION_POPUP_KEY,
  EDITING_POPUP_KEY,
  FETCH_REQUEST,
  FETCH_REQUEST_SUCCESS,
  FETCH_REQUEST_ERROR,
  SAVE_REQUEST,
  SAVE_REQUEST_SUCCESS,
  SAVE_REQUEST_ERROR, FETCH_TV_ACTIONS, FETCH_TV_ACTIONS_SUCCESS, FETCH_TV_ACTIONS_ERROR,
} from './constants';

import { fetchPoints as fetchHomePoints } from './containers/HomeNotificationPoints/actions';

export function fetchActionsStart() {
  return {
    type: FETCH_ACTIONS,
  };
}

export function fetchActionsSuccess(data) {
  return {
    data,
    type: FETCH_ACTIONS_SUCCESS,
  };
}

export function fetchActionsError(error) {
  return {
    error,
    type: FETCH_ACTIONS_ERROR,
  };
}

export function fetchTvConsolesStart() {
  return {
    type: FETCH_TV_CONSOLES,
  };
}

export function fetchTvConsolesSuccess(data) {
  return {
    data,
    type: FETCH_TV_CONSOLES_SUCCESS,
  };
}

export function fetchTvConsolesError(error) {
  return {
    error,
    type: FETCH_TV_CONSOLES_ERROR,
  };
}

export function fetchTvActionsStart(tvConsoleGuid) {
  return {
    tvConsoleGuid,
    type: FETCH_TV_ACTIONS,
  };
}

export function fetchTvActionsSuccess(data, tvConsoleGuid) {
  return {
    tvConsoleGuid,
    data,
    type: FETCH_TV_ACTIONS_SUCCESS,
  };
}

export function fetchTvActionsError(error, tvConsoleGuid) {
  return {
    tvConsoleGuid,
    error,
    type: FETCH_TV_ACTIONS_ERROR,
  };
}

export function saveActionsStart() {
  return {
    type: SAVE_ACTIONS,
  };
}

export function saveActionsSuccess(actions) {
  return {
    data: actions,
    type: SAVE_ACTIONS_SUCCESS,
  };
}

export function handleSavingActionsError(error) {
  return {
    error,
    type: SAVE_ACTIONS_ERROR,
  };
}

export function saveActionsError(error) {
  return (dispatch) => {
    dispatch(handleSavingActionsError(error));
    dispatch(openErrorPopup({
      message: 'settings.notifications.saveActionsError',
    }));
  };
}

export function saveTvActionsStart(tvConsoleGuid) {
  return {
    tvConsoleGuid,
    type: SAVE_TV_ACTIONS,
  };
}

export function saveTvActionsSuccess(actions, tvConsoleGuid) {
  return {
    tvConsoleGuid,
    data: actions,
    type: SAVE_TV_ACTIONS_SUCCESS,
  };
}

export function saveTvActionsError(error, tvConsoleGuid) {
  return {
    tvConsoleGuid,
    error,
    type: SAVE_TV_ACTIONS_ERROR,
  };
}

export function fetchPointsStart() {
  return {
    type: FETCH_POINTS,
  };
}

export function fetchPointsSuccess(data) {
  return {
    data,
    type: FETCH_POINTS_SUCCESS,
  };
}

export function fetchPointsError(error) {
  return {
    error,
    type: FETCH_POINTS_ERROR,
  };
}

export function toggleNotificationPointStart(notificationType) {
  return {
    data: notificationType,
    type: TOGGLE_NOTIFICATION_POINT,
  };
}

export function toggleNotificationPointSuccess(data) {
  return {
    data,
    type: TOGGLE_NOTIFICATION_POINT_SUCCESS,
  };
}

export function handleTogglingNotificationPointError(notificationType, error) {
  return {
    error,
    data: notificationType,
    type: TOGGLE_NOTIFICATION_POINT_ERROR,
  };
}

export function toggleNotificationPointError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleTogglingNotificationPointError(notificationType, error));
    dispatch(openErrorPopup());
  };
}

export function saveNotificationPointStart(type) {
  return {
    data: type,
    type: SAVE_NOTIFICATION_POINT,
  };
}

export function saveNotificationPointSuccess(data) {
  return {
    data,
    type: SAVE_NOTIFICATION_POINT_SUCCESS,
  };
}

export function handleSavingNotificationPointError(notificationType, error) {
  return {
    error,
    data: notificationType,
    type: SAVE_NOTIFICATION_POINT_ERROR,
  };
}

export function saveNotificationPointError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleSavingNotificationPointError(notificationType, error));
    dispatch(openErrorPopup());
  };
}

export function confirmNotificationPointCodeStart(notificationType) {
  return {
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE,
  };
}

export function confirmNotificationPointCodeSuccess(notificationType) {
  return {
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  };
}

export function confirmNotificationPointCodeError(notificationType) {
  return {
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  };
}

export function sendNotificationPointCodeStart(notificationType) {
  return {
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE,
  };
}

export function sendNotificationPointCodeSuccess(notificationType) {
  return {
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  };
}

export function handleSendingNotificationPointCodeError(notificationType, error) {
  return {
    error,
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE_ERROR,
  };
}

export function sendNotificationPointCodeError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleSendingNotificationPointCodeError(notificationType, error));
    dispatch(openErrorPopup({
      message: 'settings.common.sendNotificationPointCodeError',
    }));
  };
}

export function resetNotificationPointCodeValidation(data) {
  return {
    data,
    type: RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  };
}

export function togglePointEditingStateForSpecificPoint(data) {
  return {
    data,
    type: TOGGLE_POINT_EDITING_STATE,
  };
}

export function togglePointEditingState(data) {
  return (dispatch) => {
    dispatch(togglePointEditingStateForSpecificPoint(data));

    if (data.isEditing) {
      dispatch(openPopup(EDITING_POPUP_KEY));
    } else {
      dispatch(closePopup());
    }
  };
}

export function toggleConfirmationCodePopupForSpecificPoint(data) {
  return {
    data,
    type: TOGGLE_CONFIRMATION_CODE_POPUP,
  };
}

export function resetError() {
  return {
    type: RESET_ERROR,
  };
}

export function fetchRequestStart() {
  return {
    type: FETCH_REQUEST,
  };
}

export function fetchRequestSuccess(data) {
  return {
    data,
    type: FETCH_REQUEST_SUCCESS,
  };
}

export function fetchRequestError(error) {
  return {
    error,
    type: FETCH_REQUEST_ERROR,
  };
}

export function saveRequestStart() {
  return {
    type: SAVE_REQUEST,
  };
}

export function saveRequestSuccess(data) {
  return {
    data,
    type: SAVE_REQUEST_SUCCESS,
  };
}

export function handleSavingRequestError(error) {
  return {
    error,
    type: SAVE_REQUEST_ERROR,
  };
}

export function saveRequestError(error) {
  return (dispatch) => {
    dispatch(handleSavingRequestError(error));
    dispatch(openErrorPopup({
      message: error,
    }));
  };
}

export function fetchActions() {
  return async (dispatch) => {
    dispatch(fetchActionsStart());

    try {
      const { data: { data, error } } = await axios.get('/api/profile/settings/notifications/notifiableactions/');

      if (error) {
        dispatch(fetchActionsError(error));
      } else {
        dispatch(fetchActionsSuccess(data));
      }
    } catch (error) {
      dispatch(fetchActionsError(error.message));
    }
  };
}

export function fetchTvActions(tvConsoleGuid) {
  return async (dispatch) => {
    dispatch(fetchTvActionsStart(tvConsoleGuid));

    try {
      const { data: { list } } = await axios
        .get(`/api/profile/convergence/tvconsolenotificationstatuses/?guid=${tvConsoleGuid}`);

      if (list) {
        dispatch(fetchTvActionsSuccess(list, tvConsoleGuid));
      } else {
        dispatch(fetchTvActionsError('Ошибка получения типов уведомлений', tvConsoleGuid));
      }
    } catch (error) {
      dispatch(fetchTvActionsError(error.message, tvConsoleGuid));
    }
  };
}

export function fetchTvConsoles() {
  return async (dispatch) => {
    dispatch(fetchTvConsolesStart());

    try {
      const { data: { list } } = await axios.get('/api/profile/convergence/tvconsoles/');
      dispatch(fetchTvConsolesSuccess(list.filter((tvConsole) => !tvConsole.isTve)));
    } catch (error) {
      dispatch(fetchTvConsolesError(error.message));
    }
  };
}

export function saveActions(actions) {
  return async (dispatch) => {
    dispatch(saveActionsStart());

    try {
      await axios.post('/api/profile/settings/notifications/notifiableactions/', { actions });

      dispatch(saveActionsSuccess(actions));
    } catch (error) {
      dispatch(saveActionsError(error.message));
    }
  };
}

export function saveTvActions(actions, tvConsoleGuid) {
  return async (dispatch) => {
    dispatch(saveTvActionsStart(tvConsoleGuid));

    try {
      const { data } = await axios.post(
        '/api/profile/convergence/tvconsolenotificationstatuses/',
        { actions },
        { params: { guid: tvConsoleGuid } },
      );

      if (data.isSuccess) {
        dispatch(saveTvActionsSuccess(actions, tvConsoleGuid));
      } else {
        dispatch(saveTvActionsError('Ошибка сохранения каналов', tvConsoleGuid));
      }
    } catch (error) {
      dispatch(saveTvActionsError(error.message, tvConsoleGuid));
    }
  };
}

export function fetchPoints() {
  return async (dispatch) => {
    dispatch(fetchPointsStart());

    try {
      const { data: { data, error } } = await axios.get('/api/profile/settings/notifications/notificationpoints/');

      if (error) {
        dispatch(fetchPointsError(error));
      } else {
        dispatch(fetchPointsSuccess(data));
      }
    } catch (error) {
      dispatch(fetchPointsError(error.message));
    }
  };
}

export function toggleNotificationPoint(data) {
  return async (dispatch) => {
    dispatch(toggleNotificationPointStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/enablenotificationpoint/', data);

      dispatch(toggleNotificationPointSuccess(data));
    } catch (error) {
      dispatch(toggleNotificationPointError(data.type, error.message));
    }
  };
}

export function sendNotificationPointCode(type) {
  return async (dispatch) => {
    dispatch(sendNotificationPointCodeStart(type));

    try {
      await axios.post('/api/profile/settings/notifications/sendnotificationpointconfirmationcode/', { type });

      dispatch(sendNotificationPointCodeSuccess(type));
    } catch (error) {
      dispatch(sendNotificationPointCodeError(type, error.message));
    }
  };
}

export function toggleConfirmationCodePopup(data) {
  return async (dispatch) => {
    dispatch(toggleConfirmationCodePopupForSpecificPoint(data));

    if (data.isConfirmationOpened) {
      dispatch(openPopup(CONFIRMATION_POPUP_KEY));

      await dispatch(sendNotificationPointCode(data.type));
    } else {
      dispatch(closePopup());
    }
  };
}

export function confirmNotificationPointCode(data) {
  return async (dispatch) => {
    dispatch(confirmNotificationPointCodeStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/confirmnotificationpointcode/', data);

      dispatch(confirmNotificationPointCodeSuccess(data.type));

      await dispatch(toggleConfirmationCodePopup({
        type: data.type,
        isConfirmationOpened: false,
      }));
    } catch (error) {
      dispatch(confirmNotificationPointCodeError(data.type));
    }
  };
}

export function saveNotificationPoint(data) {
  return async (dispatch) => {
    dispatch(saveNotificationPointStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/notificationpoint/', data);

      if (data.value) {
        dispatch(saveNotificationPointSuccess(data));

        await dispatch(toggleConfirmationCodePopup({
          type: data.type,
          isConfirmationOpened: true,
        }));
      } else {
        dispatch(saveNotificationPointSuccess(data));
      }
    } catch (error) {
      dispatch(saveNotificationPointError(data.type, error.message));
    }
  };
}

export function fetchRequest() {
  return async (dispatch, getState) => {
    const { isPostpaid } = getState().application;

    if (isPostpaid) return;

    dispatch(fetchRequestStart());

    try {
      const { data } = await axios.get('/api/profile/detalization/detailperiodicrequest/');

      dispatch(fetchRequestSuccess(data));
    } catch (error) {
      dispatch(fetchRequestError(error.message));
    }
  };
}

// TODO: Fix data-conversion in component & action
export function saveRequest(payload) {
  return async (dispatch) => {
    dispatch(saveRequestStart());

    try {
      let url;
      let body;
      let status = 'active';
      const numbers = payload.numbers.filter((n) => n.active);

      if (payload.status === 'disable') {
        url = '/api/profile/detalization/createdetailperiodicrequest/';
        body = {
          startDate: payload.startDate,
          reportType: payload.format,
          numbers: numbers.map((n) => n.ctn),
        };
        status = 'active';
      } else if (numbers.length) {
        url = '/api/profile/detalization/updatedetailperiodicrequest';
        body = {
          startDate: payload.startDate,
          reportType: payload.format,
          numbers: payload.numbers,
        };
      } else {
        url = '/api/profile/detalization/deletedetailperiodicrequest';
        status = 'disable';
      }

      const { data } = await axios.post(url, body);

      if (!data.isSuccess) {
        dispatch(saveRequestError(data.errorMessage));
      } else {
        dispatch(saveRequestSuccess({
          startDate: payload.startDate,
          reportType: payload.format,
          numberStatus: payload.numbers,
          status,
        }));
      }
    } catch (error) {
      dispatch(saveRequestError(error.message));
    }
  };
}

export function fetchInitialData() {
  return (dispatch, getState) => {
    dispatch(fetchActions());
    dispatch(fetchPoints());
    dispatch(fetchRequest());
    if (getState().application.isConvergent) {
      dispatch(fetchTvConsoles());
      dispatch(fetchHomePoints());
    }
  };
}
